import { SxProps } from "@mui/material";
import { Button, ButtonProps } from "..";
import { useLocation } from "react-router-dom";

export const UpdateButton = (
  props: ButtonProps & {
    label?: string;
    theme?: "Dark" | "Standard";
  }
) => {
  const { label, onClick, theme, ...rest } = props;
  const location = useLocation();
  const hasDialog = location.pathname.includes('dialog');

  const darkModeStyle: SxProps = ({
    color: "#eff3ff",
    backgroundColor: props.disabled ? "#08519c" : "#08519c", 
    border: props.disabled ? "1px solid #08519c" : "1px solid #eff3ff",
    opacity: props.disabled ? 0.85 : 1, // subtle fade
    cursor: props.disabled ? "default" : "pointer",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.1)",
      borderColor: "#eff3ff",
    }
  });

  return (
    <Button sx={theme == "Dark" || hasDialog ? {...darkModeStyle, ...props.sx} : {...props.sx}} variant={"outlined"} onClick={onClick} {...rest}>
      {label || "Edit"}
    </Button>
  );
};
